import {ICardM, IPileM} from "./MTypes";

export default class MField {
    private hand: Array<ICardM>;
    private piles: Array<IPileM>;
    private pileMap = new Map<number, IPileM>();

    constructor() {
        this.hand = [];
        this.piles = [];
    }

    /**
     * обновить данные
     */
    public update(gameField: any, playerId: string = ''): void
    {
        // console.log('%c ### MField::update', 'color: #f0f', gameField);
        const player = gameField.players ? gameField.players[playerId] : null;
        this.hand = (player && player.cards) ? player.cards : [];
        // console.log('%c ### HAND:', 'color: #f0f', this.idHand);

        this.piles = gameField.card_stacks.map((pile: any) => pile as IPileM);
        this.piles = this.piles.filter(pile => pile.cards.length > 0);
        this.piles.forEach(pile => {
            pile.flipped = pile.cards[pile.cards.length - 1].flipped;
        });
        this.pileMap = new Map(this.piles.map(pile => [pile.id, pile]));
        // console.log('%c ### MField::update', 'color: #f0f', this.piles);
        // console.log('%c ### MField::update', 'color: #f0f', this.pileMap);
    }

    /**
     * получить пачку по ID
     */
    public getPile(id: number): IPileM | undefined
    {
        return this.pileMap.get(id);
    }

    /**
     * получить массив пачек
     */
    public get pileList(): Array<IPileM>
    {
        return this.piles;
    }

    /**
     * получить массив ID карт в руке
     */
    public get idHand(): Array<number>
    {
        return this.hand.map(card => card.id);
    }

    /**
     * получить массив ID пачек
     */
    public get idList(): Array<number>
    {
        return this.piles.map(pile => pile.id);
    }

    /**
     * Получить индекс первого эл-та в массиве
     * @param id
     */
    public getFirstCardIndex(id: number): number
    {
        return this.idHand.indexOf(id);
    }

    /**
     * получить массив пачек по списку ID
     */
    public selectPiles(ids: Array<number>): Array<IPileM>
    {
        return this.piles.filter(pile => ids.includes(pile.id));
    }

    /**
     * получить массив карт в руке по списку ID
     */
    public selectHand(ids: Array<number>): Array<ICardM>
    {
        return this.hand.filter(card => ids.includes(card.id));
    }

    /**
     * перезаписать данные
     */
    public overwrite(newField: MField): void
    {
        this.hand = newField.hand.map(card => ({...card}));
        this.piles = newField.pileList.map(pile => {
            const clone = {...pile};
            // clone.cards = pile.cards.map(card => ({...card}));
            clone.cards = pile.cards.map(card => {
                const cloneCard = {...card};
                cloneCard.paint = card.paint;
                return cloneCard;
            });
            return clone;
        });
        this.pileMap = new Map(this.piles.map(pile => [pile.id, pile]));
    }

    /**
     * action: add stack
     */
    public actionAddStack(value: {stack: IPileM}): void
    {
        const pile = value.stack;
        // console.log('%c ### addStack:', 'color: #f0f', pile);

        pile.flipped = value.stack.flipped ?? (value.stack.cards[0]?.flipped ?? false);
        pile.blockedByPlayer = value.stack.blockedByPlayer ?? '';
        pile.usedByPlayer = value.stack.usedByPlayer ?? '';
        pile.angle = value.stack.angle ?? 0;

        this.piles.push(pile);
        this.pileMap.set(pile.id, pile);
    }

    /**
     * action: delete stacks
     */
    public actionDeleteStacks(ids: Array<number>): void
    {
        ids.forEach(id => {
            this.piles = this.piles.filter(pile => pile.id !== id);
            this.pileMap = new Map(this.piles.map(pile => [pile.id, pile]));
        });
    }

    /**
     * action: disable stacks
     */
    public  actionDisableStacks(value: {ids: Array<number>, playerId: string, block: boolean}): void
    {
        value.ids.forEach(id => {
            const pile = this.pileMap.get(id);
            if (pile) {
                pile.usedByPlayer = value.playerId;
                pile.blockedByPlayer = value.block ? value.playerId : '';
            }
        });
    }

    /**
     * action: enable stacks
     */
    public actionEnableStacks(value: {ids: Array<number>}): void
    {
        value.ids.forEach(id => {
            const pile = this.pileMap.get(id);
            if (pile) {
                pile.usedByPlayer = '';
                pile.blockedByPlayer = '';
            }
        });
    }

    /**
     * action: flip pile
     */
    public actionFlipPile(value: {id: number, cards: Array<ICardM>}): void
    {
        const pile = this.pileMap.get(value.id);
        if (pile) {
            pile.cards = value.cards.map(card => ({...card}));
            pile.flipped = pile.cards[0].flipped;
        }
    }

    /**
     * action: tryMove pile
     */
    public actionMovePile(value: {id: number, x: number, y: number}): void
    {
        const pile = this.pileMap.get(value.id);
        if (pile) {
            pile.x = value.x;
            pile.y = value.y;
        }
    }

    /**
     * action: rotate pile
     */
    public actionRotatePile(value: {id: number, angle: number}): void
    {
        const pile = this.pileMap.get(value.id);
        if (pile) {
            pile.angle = value.angle;
        }
    }

    /**
     * action: shuffle pile
     */
    public actionShufflePile(value: {id: number, cards: Array<any>}): void
    {
        const pile = this.pileMap.get(value.id);
        if (pile) {
            pile.cards = value.cards.map(card => ({...card}));
            pile.shuffled = true;
        }
    }

    /**
     * action: delete card from hand
     */
    public actionDeleteHandCard(ids: Array<number>): void
    {
        ids.forEach(id => {
            const index = this.hand.findIndex(it => it.id === id);
            if (index >= 0) {
                this.hand.splice(index, 1);
            }
        });
    }

    /**
     * action: add cards to hand
     */
    public actionAddCardsToHand(value: {cards: Array<ICardM>, handIndex: number}): void
    {
        if (value.handIndex === -1) {
            this.hand = [...this.hand, ...value.cards];
        } else {
            this.hand.splice(value.handIndex, 0, ...value.cards);
        }
    }

    /**
     * action: add cards to stack
     */
    public actionAddCardsToStack(value: {id: number, cards: Array<ICardM>}): void
    {
        const pile = this.pileMap.get(value.id);
        if (pile) {
            pile.cards = [...pile.cards, ...value.cards];
        }
    }

    /**
     * action: add cards to stack
     */
    public actionRemoveCardsFromStack(value: {id: number, cardIds: Array<number>}): void
    {
        const pile = this.pileMap.get(value.id);
        if (pile) {
            pile.cards = pile.cards.filter(card => !value.cardIds.includes(card.id));
        }
    }

    /**
     * action: lock / unlock pile
     */
    public actionLockPile(id: number, locked: boolean): void
    {
        const pile = this.pileMap.get(id);
        if (pile) {
            pile.locked = locked;
        }
    }

}
